import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable ,  Subscription } from 'rxjs';

@Component({
  selector: 'app-table-selection-modal',
  templateUrl: './table-selection-modal.component.html',
  styleUrls: ['./table-selection-modal.component.scss']
})
export class TableSelectionModalComponent implements OnInit, OnDestroy {

  loading = true;

  @Input()
  selectables: Observable<any[]>;

  selectablesSubscription: Subscription;

  selected: any[] = [];

  @Output()
  selectedChange = new EventEmitter<any[]>();

  @Input()
  fieldsNames: String[];

  @Input()
  fieldsEntries: String[];

  private data: any[] = [];

  constructor() {
  }

  ngOnInit() {
    this.selectables.subscribe(data => {
      this.data    = data;
      this.loading = false;
    });
  }

  public toggleSelection(index: number) {
    const idx = this.selected.indexOf(this.data[index]);
    if (idx === -1) { // not contained
      this.selected.push(this.data[index]);
    } else { // contained
      this.selected.splice(idx, 1);
    }
    this.selectedChange.emit(this.selected);
  }

  public isSelected(index: number): boolean {
    return this.selected.indexOf(this.data[index]) > -1;
  }

  ngOnDestroy() {
    if (this.selectablesSubscription) {
      this.selectablesSubscription.unsubscribe();
    }
  }

}
